import { FaClipboardCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardFormulario = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.atendimento_info;

    if (!info) return null;

    const servicoTitulo = info.titulo_botao || "Formulário Respondido";
    const titulo = `${servicoTitulo} - ${info.beneficiario_nome}`;
    const descricao = `Programa: ${info.programa_nome} - Verifique os dados no atendimento.`;

    let dataDisplay = notif.data_criacao || "-";

    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
             dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {}
    }

    const handleClick = () => {
        const identificador = info.uuid || info.id;
        navigate(`/atendimentos/edit/${identificador}`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaClipboardCheck />}
            color="secondary"
            text="text-secondary"
            label="Formulário de Serviço"
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardFormulario;
